import { makeStyles } from '@material-ui/core';

export default makeStyles(theme => ({
  root: {
    padding: theme.spacing(1)
  },
  table: {
    maxWidth: '100%'
  }
}));
